// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ErrorFileSection from "../../../to-be-migrated/presentation/insti-dashboard/advance-payments/views/ErrorFileSection.bs.js";
import * as Caml_js_exceptions from "../../../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as ReMapUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ReMapUtils.bs.js";
import * as CsvFileEncoder$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/csv-parser/CsvFileEncoder.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function getCityItems(georegions) {
  return List.map((function (param) {
                var name = param.name;
                return {
                        key: name.toLowerCase(),
                        value: name,
                        text: name
                      };
              }), georegions);
}

function getErrorCsvFileContent(rowList, fileName, header) {
  var headerRow = header !== undefined ? $$Array.to_list(header) : ({
        hd: "driver_msisdn",
        tl: {
          hd: "vehicle_number",
          tl: {
            hd: "amount",
            tl: {
              hd: "partner_comment",
              tl: {
                hd: "admin_comment",
                tl: /* [] */0
              }
            }
          }
        }
      });
  var errorCsvContent_1 = List.map($$Array.to_list, $$Array.to_list(rowList));
  var errorCsvContent = {
    hd: headerRow,
    tl: errorCsvContent_1
  };
  return React.createElement(ErrorFileSection.make, {
              fileName: fileName,
              csvFileContent: CsvFileEncoder$Catalyst.getFileContent(errorCsvContent),
              className: "u-padding-small"
            });
}

function invalidRequestResponseCsvContent(requests, requestErrors, fileName) {
  var errorMap = List.fold_left((function (map, error) {
          return Curry._3(ReMapUtils$Catalyst.StringMap.add, error.request.driver_msisdn, error.error_message, map);
        }), ReMapUtils$Catalyst.StringMap.empty, requestErrors);
  var rowList = $$Array.of_list(List.map((function (request) {
              var admin_comment = request.admin_comment;
              var partner_comment = request.partner_comment;
              var amount = request.amount;
              var vehicle_number = request.vehicle_number;
              var driver_msisdn = request.driver_msisdn;
              try {
                var error_message = Curry._2(ReMapUtils$Catalyst.StringMap.find, request.driver_msisdn, errorMap);
                return [
                        driver_msisdn,
                        vehicle_number,
                        amount.toString(),
                        partner_comment,
                        admin_comment,
                        error_message
                      ];
              }
              catch (raw_exn){
                var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                if (exn.RE_EXN_ID === "Not_found") {
                  return [
                          driver_msisdn,
                          vehicle_number,
                          amount.toString(),
                          partner_comment,
                          admin_comment
                        ];
                }
                throw exn;
              }
            }), requests));
  return getErrorCsvFileContent(rowList, fileName, undefined);
}

function getFileDuplicationMessage(fileName) {
  return "The file " + (fileName + " has already\n  been uploaded. Kindly make sure you are uploading\n  the right file. You can rename the file if you are sure\n  about transactions");
}

function getErrorSection(fileUploadResult, fileName, requestStatus) {
  if (fileUploadResult.TAG === /* Ok */0) {
    if (typeof requestStatus === "number") {
      return null;
    }
    switch (requestStatus.TAG | 0) {
      case /* Loading */0 :
          return null;
      case /* Live */1 :
          var error = requestStatus._0;
          if (error.TAG === /* Ok */0) {
            return null;
          }
          var error$1 = error._0;
          if (error$1) {
            return React.createElement("div", {
                        className: "porter-form__section"
                      }, invalidRequestResponseCsvContent(fileUploadResult._0, error$1._0, fileName));
          } else {
            return React.createElement("div", {
                        className: "porter-form__section"
                      }, React.createElement(ErrorDisplayComponent$Catalyst.make, {
                            error: /* DefaultError */{
                              _0: {
                                title: {
                                  TAG: /* Custom */0,
                                  _0: "File duplicated"
                                },
                                message: getFileDuplicationMessage(fileName)
                              }
                            }
                          }));
          }
      case /* Error */2 :
          return React.createElement("div", {
                      className: "porter-form__section"
                    }, React.createElement(ErrorDisplayComponent$Catalyst.make, {
                          error: requestStatus._0
                        }));
      
    }
  } else {
    var error$2 = fileUploadResult._0;
    if (error$2.TAG === /* ErrorRows */0) {
      return React.createElement("div", {
                  className: "porter-form__section"
                }, getErrorCsvFileContent(error$2._1, fileName, error$2._0));
    } else {
      return React.createElement("div", {
                  className: "porter-form__section"
                }, React.createElement(ErrorDisplayComponent$Catalyst.make, {
                      error: /* DefaultError */{
                        _0: {
                          title: {
                            TAG: /* Custom */0,
                            _0: "CSV error"
                          },
                          message: error$2._0
                        }
                      }
                    }));
    }
  }
}

export {
  getCityItems ,
  getErrorCsvFileContent ,
  invalidRequestResponseCsvContent ,
  getFileDuplicationMessage ,
  getErrorSection ,
  
}
/* react Not a pure module */
